var isString = require('@antv/util/lib/type/isString');
var cloneDeep = require('@antv/util/lib/clone');

var _require = require('../data-set'),
    registerConnector = _require.registerConnector;

registerConnector('default', function (dataView, dataSet) {
  if (isString(dataView)) {
    dataView = dataSet.getView(dataView);
  }
  if (!dataView) {
    throw new TypeError('Invalid dataView');
  }
  return cloneDeep(dataView.rows);
});


//////////////////
// WEBPACK FOOTER
// ./src/connector/default.js
// module id = 354
// module chunks = 0